module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8y42OB/cover.jpeg?1684514751861",
      "alt": "This image is the cover for the book Unparalleled Divine Power, Book 20"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Unparalleled Divine Power, Book 20\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('strong', [_vm._v("Getting ancient talent and supernatural power,  having an immortal body... He will take back what he lost with his own efforts!")])]), _c('p'), _c('p', [_vm._v("In a world which respects martial arts, strength naturally determines everything. Qin family, a family with a history of only more than 50 years, occupied the position of the largest force in Zi Yang town 40 years ago. In order to obtain the his father's status of clan leader, Qin Xiao was framed by his uncle. As a result, his foundation of cultivation was destroyed. But how could Qin Xiao be reconciled? Getting ancient talent and supernatural power,  having an immortal body... He will take back what he lost with his own efforts!")]), _c('p'), _c('p', [_c('strong', [_vm._v("☆About the Author☆")])]), _c('p'), _c('p', [_vm._v("Can Shang, an online novel writer, is good at creating oriental fantasy novels. His has written two novels, they are Unparalleled Divine Power and Everlasting God Emperor. The motto of Can Shang is \"love life, love writing\".")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Can Shang, Babel Novel\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Funstory\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0